module.exports = __webpack_public_path__ + "img/caav.0608a672.jpg";